'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getMatchForJob = require('./getMatchForJob');

var _getMatchForJob2 = _interopRequireDefault(_getMatchForJob);

var _constants = require('./constants');

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMatchingJobs = function getMatchingJobs(jobs, userPrefs, data) {
  var jobsWithMatches = (0, _keys2.default)(jobs).map(function (id) {
    var job = jobs[id];
    return (0, _extends3.default)({}, job, {
      id: id,
      matches: (0, _getMatchForJob2.default)(job, userPrefs, data, _constants2.default)
    });
  });
  var sorted = jobsWithMatches.sort(function (b, a) {
    return a.matches.match - b.matches.match;
  });
  return sorted;
};

exports.default = getMatchingJobs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/utils/match/getMatchingJobs.js
// module id = 454
// module chunks = 0